var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayersEditable32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.172 13.945l.731-.73 5.597 3.277L16 25 1.5 16.492 16 8l.89.52-.732.732L16 9.159 3.478 16.493 16 23.841l12.522-7.348zm2.558 6.499l1.792 1.05L16 28.84 3.478 21.493l1.792-1.05-.989-.58-2.781 1.63L16 30l14.5-8.508-2.781-1.629zm2.915-16.562a1.203 1.203 0 0 1 .037 1.726L27.88 7.406v.001l-9.565 9.567-5.465 2.342a.306.306 0 0 1-.402-.402l2.342-5.465L26.156 2.083a1.203 1.203 0 0 1 1.726.037zM17.324 16.311l-1.871-1.87-1.403 3.273zm9.584-9.344l-2.11-2.111-8.759 8.757 2.112 2.111zm2.03-2.378l-1.761-1.761a.285.285 0 0 0-.193-.092.163.163 0 0 0-.12.054l-1.36 1.359 2.111 2.11 1.36-1.358c.133-.133-.02-.294-.038-.312z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersEditable32);
export default __webpack_public_path__ + "static/media/layers-editable-32.42718f69f3252b8a5afb03888f5ebfe7.svg";
export { ForwardRef as ReactComponent };